import React, { useState } from 'react';
import Button from '../../components/common/Button';
import FormField from '../../components/common/FormField';
import Card from '../../components/common/Card';
import { ClientDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';

interface ClientFormProps {
  initialValues: ClientDTO;
  onSubmit: (data: ClientDTO) => void;
  onCancel: () => void;
}

const ClientForm: React.FC<ClientFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
}) => {
  const [formData, setFormData] = useState<ClientDTO>(initialValues);

  const validationRules: ValidationRules = {
    companyName: [{ required: true, message: 'Company Name is required' }],
    contactPerson: [{ required: true, message: 'Contact Person is required' }],
    number: [{ required: true, message: 'Number is required' }],
    email: [{ required: true, message: 'Email is required' }]
  };

  const { errors, validate } = useFormValidation<ClientDTO>(validationRules);

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate(formData)) {
      onSubmit(formData);
    }
  };

  return (
    <Card>
      <form onSubmit={handleFormSubmit}>
        <div className="mb-4">
          <FormField
            id="companyName"
            label="Company Name"
            type="text"
            value={formData.companyName || ''}
            onChange={(e) => handleChange(e, setFormData)}
            placeholder="Enter Company Name"
            required={true}
            error={errors.companyName}
          />
          <FormField
            id="contactPerson"
            label="Contact Person"
            type="text"
            value={formData.contactPerson || ''}
            onChange={(e) => handleChange(e, setFormData)}
            placeholder="Enter Contact Person"
            required={true}
            error={errors.contactPerson}
          />
          <FormField
            id="number"
            label="Number"
            type="text"
            value={formData.number || ''}
            onChange={(e) => handleChange(e, setFormData)}
            placeholder="Enter Number"
            required={true}
            error={errors.number}
          />
          <FormField
            id="email"
            label="Email"
            type="text"
            value={formData.email || ''}
            onChange={(e) => handleChange(e, setFormData)}
            placeholder="Enter Email"
            required={true}
            error={errors.email}
          />

        </div>
        <div className="flex justify-end space-x-4">
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="submit">Save</Button>
        </div>
      </form>
    </Card>
  );
};

export default ClientForm;
